import axios from 'axios'
import store from '@/store'
import { EventBus } from '@/functions/event-bus'

// Cuenta de peticiones activas
let activeRequests = 0

function toggleLoading(state) {
  EventBus.$emit('toggle-loading', state)
}
const instance = axios.create({
  baseURL: process.env.VUE_APP_BASE_API,
  headers: {
    'Content-Type': 'application/json',
    'X-API-KEY': 'c333786c4acbe6cf110591592cc446cd8831d0df0f7eb35e55fa689155b163cf'
  },
  withCredentials : true,
})

// Interceptor de request
instance.interceptors.request.use(config => {
  const token = localStorage.getItem('token')
  if (token) {
    config.headers.Authorization = `Bearer ${token}`
  }

  activeRequests++
  toggleLoading(true)

  return config
}, error => {
  activeRequests--
  if (activeRequests === 0) toggleLoading(false)
  return Promise.reject(error)
})

// Interceptor de response
instance.interceptors.response.use(
  response => {
    activeRequests--
    if (activeRequests === 0) toggleLoading(false)
    return response
  },
  error => {
    activeRequests--
    if (activeRequests === 0) toggleLoading(false)

    if (error.response && error.response.status === 401) {
      store.dispatch('logout')
      localStorage.removeItem('token')
      // Puedes redirigir aquí si quieres
      // router.push('/login')
    }

    return Promise.reject(error)
  }
)

export default instance
